import React from "react";
import mans from "../../img/users/fr.png";
import FriendsOrUsers from "../../Utilits/FriendsOrUsers";
import User from "../Users/User";


const Friends = (props) => {
    let friends = props.friends.map(friend => <User name={friend.name}
                                                    status={friend.status}
                                                    img={friend.photos.small}
                                                    id={friend.id}
                                                    key={friend.id}
                                                    follow={props.follow}
                                                    followed={friend.followed}
                                                    unFollow={props.unFollow}
                                                    waitingSubscripe={props.waitingSubscripe}/>);
    return(
        <FriendsOrUsers title={"Ваши друзья"}
                        text={"Добро пожаловать на страницу ваших друзей, здесь вы будете видеть смешных,грустных, тупых или прекраснейших ваших друзей"}
                        img={mans}
                        totalCount={props.totalCount}
                        activePage={props.activePage}
                        setActivePage={props.setActivePage}
                        pageSize={props.pageSize}
                        countPagesInPortion={window.innerWidth > 960 ? 10 : 5}
                        people={friends}
                        onSubmit={props.onSubmit}
        />
    )
};

export default Friends